import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, throwError } from 'rxjs'
import { catchError, map, tap } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'
import { ApiHttpService } from '../providers/api-http.service'
import { CookieService } from 'ngx-cookie-service'
import { UuidServiceService } from './uuid-service'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root'
})
export class ProgressiveProfileService extends ApiHttpService {
  serviceQuestions: any
  ppQuestionsObject = new BehaviorSubject({})
  ppQuestionsData = this.ppQuestionsObject.asObservable()

  constructor (
    public override http: HttpClient,
    public cookieService: CookieService,
    public uuid: UuidServiceService,
    private router: Router
  ) {
    super(http)
  }

  getProgressiveProgileQuestions (country: any, language: any): any {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Correlation-ID': this.uuid.uuidv4(),
        Authorization: this.cookieService.get('wircognito-new-access-token'),
        'Refresh-Token': this.cookieService.get('wircognito-refresh')
      }),
      params: new HttpParams({
        fromString: 'country=' + country + '&lang=' + language
      })
    }
    const endpoint = environment.getProgressiveProfileQuestionsApi
    return this.get(endpoint, options).pipe(map((result) => result))
  }

  getPPqstns (): Observable<any> {
    const sfResponse: any = localStorage.getItem('sfResponse')
    const officeDetails: any = JSON.parse(sfResponse)
    const country = officeDetails?.wir_cognito_country
    const language = localStorage.getItem('languageSelected') || 'EN'

    if (!country) {
      this.router.navigateByUrl('/error')
      return new Observable()
    }

    return this.getProgressiveProgileQuestions(country, language).pipe(
      tap((ppQuestions: any) => {
        this.ppQuestionsObject.next(ppQuestions)
        this.serviceQuestions = ppQuestions
      }),
      catchError((error) => {
        console.error(error)
        this.router.navigateByUrl('/error')
        return throwError(() => error)
      })
    )
  }
}
